import React from 'react';
import { styled } from '@mui/material/styles';

interface ResizeHandleProps {
  onMouseDown: (e: React.MouseEvent) => void;
}

const StyledResizeHandle = styled('div')(({ theme }) => ({
  position: 'absolute',
  right: 0,
  bottom: 0,
  width: 20,
  height: 20,
  cursor: 'se-resize',
  '&::before': {
    content: '""',
    position: 'absolute',
    right: 3,
    bottom: 3,
    width: 9,
    height: 9,
    borderRight: `2px solid ${theme.palette.text.secondary}`,
    borderBottom: `2px solid ${theme.palette.text.secondary}`,
  },
}));

const ResizeHandle: React.FC<ResizeHandleProps> = ({ onMouseDown }) => (
  <StyledResizeHandle onMouseDown={onMouseDown} />
);

export default ResizeHandle;
